import _ from 'lodash';
import { PETS } from '../constants';

export default function getAvailablePets(pets) {
	// filter down to the available pets and key them by ID
	// so we can easily grab them.
	const petsById = _.keyBy(_.filter(pets, pet => !pet.isComingSoon), 'sku');
	// Return an array of available pets sorted by the
	// order in the PETS array.
	return _.reduce(PETS, (newPetsArray, pet) => {
		if (petsById[pet.sku]) newPetsArray.push(petsById[pet.sku]);
		return newPetsArray;
	}, []);
}



// WEBPACK FOOTER //
// ./src/selectors/getAvailablePets.js